module.exports = __webpack_public_path__ + "static/img/4-3.042fb04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/4-3.jpg
// module id = JfvB
// module chunks = 0